import Rule from "../../../common/rule";
import { isSeriesOvertime } from "../../utils/overtime-utils";

export default class ResetField extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedHistoryIndex === play.fragments?.length &&
            ruleContext.resetField
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { spots } = eventConfiguration;
        const { overtimeStartingYardline, driveStartingYardline } = spots;

        // With OT Kickoffs on, overtime spots the ball as regulation does
        // and Overtime Starting Yardline is not used (PSTATS-1268).
        const startingYardline = isSeriesOvertime(gameContext)
            ? overtimeStartingYardline
            : driveStartingYardline;

        if (gameContext.isHomePossession()) {
            gameContext.setFieldPosition(startingYardline);
        } else {
            gameContext.setFieldPosition(
                gameContext.getFieldLength() - startingYardline
            );
        }

        ruleContext.setAwardFirstDown(true);
    }
}
